// extracted by css-extract-rspack-plugin
export default {"wrapper":"_d12d1e97","reverse":"_50d5aa24","staticContainer":"_9c0e151b","htmlContainer":"_e2b20d1e","border":"_e60c46c8","staticText":"_af9bbc61","termsLink":"_71b68819"};